import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CompanyContextService } from '../services/company-context.service';

/**
 * Yalnızca Plaid banka entegrasyonu (open banking) destekleyen ülkelerin (GB)
 * şirketlerine banka akışı sayfalarını açar. Desteklenmiyorsa panoya yönlendirir.
 */
export const bankFeedsGuard: CanActivateFn = () => {
  const companyContext = inject(CompanyContextService);
  const router = inject(Router);

  return companyContext.supportsFeature('bankFeeds') ? true : router.createUrlTree(['/dashboard']);
};
